import { t } from 'i18next';
import { camelCase, upperFirst } from 'lodash';

import { IManagedNote } from 'core/components';
import { Color } from 'theme/enums';

import { PartNoteType } from './enums';
import { IPartNote, IPartNoteForm } from './types';

export const getNoteLabel = (type: PartNoteType | string, withNoteSuffix = true) =>
  t(`labelCreate${upperFirst(camelCase(type))}${withNoteSuffix ? 'Note' : ''}`);

export const mapNotesToManagedNotes = (notes: IPartNote[] = []) =>
  notes.map((note) => ({
    ...note,
    isEditable: true,
    isDeletable: true,
    category: {
      label: getNoteLabel(note.type, false),
      color: Color.PRIMARY,
    },
    sx: { backgroundColor: 'primary.50' },
  }));

export const getMappedNotesArrByType = (notes: IPartNote[], type: PartNoteType): IManagedNote[] =>
  mapNotesToManagedNotes(notes.filter((note) => note.type === type) || [])
    .filter((note) => note.type === type)
    .reverse();

export const mapCreatePartNotes = (data: IPartNoteForm): IPartNote[] => {
  const notes: IPartNote[] = [];

  Object.entries(data.notes).forEach(([type, note]) => {
    if (note.enabled && note.content) {
      notes.push({
        type: type as PartNoteType,
        content: note.content,
      });
    }
  });

  return notes;
};
